/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import DialogContent from "@mui/material/DialogContent";

import Grid from "@mui/material/Grid";
import Input from "../../../component/inputpm";
import Icon from "@mui/material/Icon";
import Loader from "../../../component/loader";

import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import { Divider } from "@mui/material";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import { Tooltip, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import { makeStyles } from '@mui/styles';

const UploadDocumentsDialog = (props) => {
  const t = props.t;
  const [data, setData] = useState({
    docEffectiveDate: "",
    docExpiryDate: "",
    documentDescription: "",
    base64PdfDocument: "",
    documentFile: "",
  });
  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     },
  // });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    error: false,
    message: "",
  });
  const onChange = (e) => {
    setError({
      error: false,
      message: "",
    });
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };
  const onDocumentUpload = (event) => {
    let format = event.target.files[0].name
      .substring(event.target.files[0].name.lastIndexOf(".") + 1)
      .toLowerCase();
    setError({
      error: false,
      message: "",
    });
    if (format === "pdf") {
      setLoading(true);
      let selectedFile = event.target.files;
      let file = null;
      let fileName = "";
      //Check File is not Empty
      if (selectedFile.length > 0) {
        // Select the very first file from list
        let fileToLoad = selectedFile[0];
        fileName = fileToLoad.name;
        // FileReader function for read the file.
        let fileReader = new FileReader();
        // Onload of file read the file content
        fileReader.onload = function (fileLoadedEvent) {
          file = fileLoadedEvent.target.result;
        };
        // Convert data to base64
        fileReader.readAsDataURL(fileToLoad);
      }
      setTimeout(() => {
        setData({
          ...data,
          base64PdfDocument: file,
          documentFile: fileName,
        });
        setLoading(false);
      }, 2000);
    } else {
      setError({
        error: true,
        message: t("INVALID_FILE_FORMAT"),
      });
    }
  };
  const validateContractDoc = () => {
    if (!data.base64PdfDocument) {
      setError({
        error: true,
        message: t("DOCUMENT_FILE_IS_REQUIRED"),
      });
    } else {
      return true;
    }
  };
  const uploadDocument = () => {
    if (validateContractDoc()) {
      let docData = {
        type: "SERVICE_AGREEMENT",
        signing: {
          sender: {
            id: props.providerId,
            type: props.providerType,
            locations: [
              {
                pageNumber: 3,
                x: 155,
                y: 233,
                type: "FULL_SIGNATURE",
              },
              {
                pageNumber: 4,
                x: 234,
                y: 432,
                type: "INITIAL",
              },
            ],
          },
          receiver: {
            id: props.selectedContractReceiver.id
              ? props.selectedContractReceiver.id
              : "",
            type: props.selectedContractReceiver.type,
            locations: [
              {
                pageNumber: 1,
                x: 201,
                y: 102,
                type: "INITIAL",
              },
              {
                pageNumber: 10,
                x: 452,
                y: 276,
                type: "FULL_SIGNATURE",
              },
            ],
          },
        },
        document: {
          name: data.documentFile,
          format: "PDF",
          status: "AVAILABLE",
          effectiveDate: props.effectiveDate,
          expiryDate: props.expiryDate ? props.expiryDate + " 00:00:00" : "",
          description: data.documentDescription,
          data: data.base64PdfDocument,
        },
      };
      setLoading(true);
      BusApiCall(
        "POST",
        `${constants.busV4Url}/providers/${props.providerId}/contracts/${props.contractId}/items`,
        docData,
      )
        .then((res) => {
          setLoading(false);
          setData({
            ...data,
            docEffectiveDate: "",
            docExpiryDate: "",
            documentDescription: "",
            base64PdfDocument: "",
            documentFile: "",
          });
          props.close(t("DOCUMENT_UPLOADED_SUCCESSFULLY"), true);
        })
        .catch((err) => {
          setLoading(false);
          if (err.response && err.response.data && err.response.data.message) {
            props.close(err.response.data.message, false);
          } else {
            props.close(t("DEFAULT_ERROR_MESSAGE"), false);
          }
        });
    }
  };

  const closeDialog = () => {
    setData({
      ...data,
      docEffectiveDate: "",
      docExpiryDate: "",
      documentFile: "",
      documentDescription: "",
      base64PdfDocument: "",
    });
    props.close();
  };

  // const classess = useStyles();

  return (
    <>
      <Dialog
        disableScrollLock={true}
        open={props.open}
        maxWidth="md"
        fullWidth={true}
        PaperComponent={DraggableDialogPaper}
      // PaperProps={{
      //     className: classess.resizablePaper
      // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <Grid container spacing={2}>
            <Grid
              item
              size={{
                xs: 10,
              }}
            >
              {t("ADD_A_DOCUMENT")} {props.title}
            </Grid>
            <Grid
              item
              align={"right"}
              size={{
                xs: 2,
              }}
            >
              <Tooltip title={t("CLOSE")}>
                <IconButton
                  onTouchStart={() => closeDialog()}
                  onClick={() => closeDialog()}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <Input
                inputProps={{
                  id: "documentFile",
                  accept: "application/pdf",
                }}
                type="file"
                name={"documentFile"}
                className="custom-file-input"
                onChange={(event) => onDocumentUpload(event, "documentFile")}
                source={data.documentFile}
              />
              <label htmlFor="documentFile" className={"input-file-label"}>
                <Icon>attach_file</Icon>
                <label>
                  {" "}
                  {data.documentFile ? (
                    data.documentFile
                  ) : (
                    <span className="input-file-placeholder">
                      {t("UPLOAD_DOCUMENT_FILE_PDF_ONLY")}
                    </span>
                  )}
                </label>
              </label>
            </Grid>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <Input
                size={"small"}
                variant={"outlined"}
                name={"documentDescription"}
                value={data.documentDescription}
                onChange={(event) => onChange(event)}
                placeholder={t("DOCUMENT_DESCRIPTION")}
                inputProps={{ rows: 2, cols: 31 }}
                multiline={true}
              />
            </Grid>

            {/* <Grid item xs={6} >
                            <Button onClick={this.markDocument}> Mark For Sign </Button>
                        </Grid>
                        <Grid item xs={1} ></Grid> */}
            {error.error && (
              <Grid
                size={{
                  xs: 12,
                }}
              >
                {error.message}
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Box style={{ width: '100%' }}>
            <Grid container spacing={2}>
              <Grid
                item
                align={"right"}
                size={{
                  xs: 12,
                }}
              >
                <Button onClick={() => uploadDocument()} color="primary">
                  {t("UPLOAD")}
                </Button>
              </Grid>
            </Grid>
          </Box>
          {/* <Button onClick={event => props.close(true)} color="primary">Upload</Button> */}
          {/* <Button onClick={event => closeDialog()} color="primary">{t('CANCEL')}</Button> */}
        </DialogActions>
      </Dialog>
      <Loader loading={loading} />
    </>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

export default withTranslation("translations")(UploadDocumentsDialog);
